/**
 * @file 模型选型组件入口
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import ModelBanner from './components/banner/Banner';
import ModelCondition from './components/modelCondition/ModelCondition';
import ModelResult from './components/modelResult/ModelResult';
import { useSmrtHooks } from './SmrtHooks';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

const Smrt: React.FC = () => {
    const hookData = useSmrtHooks();
    const { resultStatus } = hookData;
    return (
        <ConfigProvider locale={zhCN}>
            <Header />
            <div className="paddle-model-wrapper">
                <div className="paddle-model">
                    <ModelBanner />
                    {!resultStatus ? <ModelCondition {...hookData} /> : <ModelResult {...hookData} />}
                </div>
            </div>

            <Footer />
        </ConfigProvider>
    );
};

export default Smrt;
